import { CLEAR_SITE_DATA } from '../application';
import {
  REQUEST_USERS,
  REQUEST_LIMITED_USERS,
  RECEIVE_USERS,
  RECEIVE_LIMITED_USERS,
  RECEIVE_USER,
} from './actions';

const initialState = {
  users: {},
  limitedUsers: [],
  photos: {},
  loadingUsers: true,
  loadingLimitedUsers: true,
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case REQUEST_USERS: {
      return { ...state, loadingUsers: true };
    }
    case RECEIVE_USERS: {
      const { users } = action;

      return {
        ...state,
        users,
        loadingUsers: false,
      };
    }
    case REQUEST_LIMITED_USERS: {
      return { ...state, loadingLimitedUsers: true };
    }
    case RECEIVE_LIMITED_USERS: {
      return { ...state, limitedUsers: action.users, loadingLimitedUsers: false };
    }
    case RECEIVE_USER: {
      const { oid, user } = action;
      return {
        ...state,
        users: {
          ...state.users,
          [oid]: user,
        },
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
